import { render, staticRenderFns } from "./FinanceremittanceInfoBox.vue?vue&type=template&id=7b732eb1"
import script from "./FinanceremittanceInfoBox.vue?vue&type=script&lang=js"
export * from "./FinanceremittanceInfoBox.vue?vue&type=script&lang=js"
import style0 from "./FinanceremittanceInfoBox.vue?vue&type=style&index=0&id=7b732eb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports